import React from 'react'
import { connect } from 'react-redux'
import { reduxForm, getFormValues, Field, SubmissionError } from 'redux-form'
import { Button } from 'semantic-ui-react'
import { Dialog, DialogTitle, DialogContent, DialogActions } from '@material-ui/core'
import FieldInput, { InputType as type } from 'components/SemanticForm'
import { ContactModalContainer } from './styled'
import { validations, validateCase as vCase } from 'core/validate'

const VendorContactModal = (props) => {
  const { valueForm, handleSubmit, onSubmitContact, closeModal, contactData, clearContactData, listContact } = props
  const isNew = contactData ? false : true

  const submitUser = () => {
    var emailDuplicate = false
    if (isNew) {
      if (listContact.find(x => x.email === valueForm.email)) emailDuplicate = true
    } else {
      if (contactData.email !== valueForm.email) {
        if (listContact.find(x => x.email === valueForm.email)) emailDuplicate = true
      }
    }

    if (!emailDuplicate) {
      onSubmitContact(valueForm, isNew, contactData)
      if (!isNew) clearContactData()
      closeModal()
    } else {
      throw new SubmissionError({ email: 'This email is not available!' })
    }
  }

  const onEmailFocusOut = (email) => {
    if (email) {
      if (email.match(/^([\w.%+-]+)@([\w-]+\.)+([\w]{2,})$/i)) {
        var emailDuplicate = false
        if (isNew) {
          if (listContact.find(u => u.email === email)) emailDuplicate = true
        } else {
          if (contactData.email !== email) {
            if (listContact.find(u => u.email === email)) emailDuplicate = true
          }
        }

        if (emailDuplicate) {
          throw new SubmissionError({ email: 'This email is not available!' })
        }
      }
    }
  }

  return (
    <Dialog open={true} maxWidth='sm' fullWidth style={{ zIndex: 10 }}>
      <DialogTitle>Vendor Contact</DialogTitle>
      <DialogContent>
        <form>
          <ContactModalContainer>
            <div className='rowFields'>
              <Field name='firstname' label='Firstname' require type={type.text} component={FieldInput} />
              <Field name='lastname' label='Lastname' require type={type.text} component={FieldInput} />
            </div>
            <div className='rowFields'>
              <Field 
                name='email' 
                label='Email' 
                require 
                onBlur={(e, value) => {
                  onEmailFocusOut(value)
                }}
                type={type.text} 
                component={FieldInput} 
              />
              <Field name='mobile' label='Mobile' type={type.text} component={FieldInput} />
            </div>
            <div className='rowFields'>
              <Field name='telephone' label='Telephone' type={type.text} component={FieldInput} />
              <Field name='extension' label='Extension' type={type.text} component={FieldInput} />
            </div>
          </ContactModalContainer>
        </form>
      </DialogContent>
      <DialogActions>
        <form onSubmit={handleSubmit(values => submitUser())}>
          <Button
            color='blue'
            content={isNew ? 'Add' : 'Save'}
            type='submit'
          />
          <Button
            color='red'
            content='Cancel'
            onClick={() => {
              clearContactData()
              closeModal()
            }}
          />
        </form>
      </DialogActions>
    </Dialog>
  )
}

const mapStateToProps = (state, props) => {
  const contactData = props.contactData || {}
  return ({
    valueForm: getFormValues('formContactUser')(state) || {},
    initialValues: {
      id: contactData.id || null,
      firstname: contactData.firstname || '',
      lastname: contactData.lastname || '',
      email: contactData.email || '',
      mobile: contactData.mobile || '',
      telephone: contactData.telephone || '',
      extension: contactData.extension || '',
    }
  })
}
  
const mapDispatchToProps = {
}

const validate = (values) => {
  let errors = {}
  validations(values, 'firstname', [vCase.require], errors)
  validations(values, 'lastname', [vCase.require], errors)
  validations(values, 'mobile', [vCase.maxLength30], errors)
  validations(values, 'telephone', [vCase.maxLength30], errors)
  validations(values, 'extension', [vCase.maxLength10], errors)

  if (!values.email) {
    errors.email = 'Require!'
  } else {
    if (!values.email.match(/^([\w.%+-]+)@([\w-]+\.)+([\w]{2,})$/i)) {
      errors.email = 'This email is wrong format!'
    }
  }

  return errors
}

const VendorContactForm = reduxForm({
  form: 'formContactUser',
  enableReinitialize: true,
  validate
})(VendorContactModal)

export default connect(mapStateToProps, mapDispatchToProps)(VendorContactForm)